import { Controller } from 'stimulus'

// Smooth-scrolls the page to another element on click, then focuses its first
// field. Used for small "jump to settings" affordances that link down to a
// section further below on the page (e.g. from the live dashboard header down
// to the settings forms beneath it).
export default class ScrollTo extends Controller {
  static values = { selector: String }

  jump() {
    const target = document.querySelector(this.selectorValue)
    if (!target) return

    target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    // preventScroll so focusing doesn't fight with the smooth-scroll already under way.
    target.querySelector('input, textarea, select')?.focus({ preventScroll: true })
  }
}
